// src/components/Modal.js
import React from "react";

const Modal = ({ title, message, onClose, onConfirm, confirmText, cancelText }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white dark:bg-neutral-900 p-6 rounded shadow-md w-96 mx-auto text-center">
        <h2 className="text-lg font-semibold mb-4 text-text-light dark:text-text-dark">{title}</h2>
        <p className="mb-4 text-text-light dark:text-text-dark">{message}</p>
        <div className="items-center justify-between gap-4">
          <button
            onClick={onConfirm}
            className="btn-primary w-full"
          >
            {confirmText}
          </button>
          <button
            onClick={onClose}
            className="bbtn-primary w-full"
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
